module.exports = __webpack_public_path__ + "img/rounded.1508bc3.gif?v=1764823240413";